// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file authenticator.proto (package domain, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ProfileAuthenticatorLock } from "./locks_pb";
import { file_locks } from "./locks_pb";
import type { AuthenticatorType } from "./authenticator_type_pb";
import { file_authenticator_type } from "./authenticator_type_pb";
import type { WebauthnPrfSupportStatus } from "./webauthn_prf_support_status_pb";
import { file_webauthn_prf_support_status } from "./webauthn_prf_support_status_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file authenticator.proto.
 */
export const file_authenticator: GenFile = /*@__PURE__*/
  fileDesc("ChNhdXRoZW50aWNhdG9yLnByb3RvEgZkb21haW4iyAQKEUF1dGhlbnRpY2F0b3JEYXRhEjUKEmF1dGhlbnRpY2F0b3JfdHlwZRgMIAEoDjIZLmRvbWFpbi5BdXRoZW50aWNhdG9yVHlwZRInCh9oaWdoX3NlY3VyaXR5X2xvZ2luX3NpZ19wdWJfa2V5GAIgASgMEioKImhpZ2hfc2VjdXJpdHlfaWRlbnRpdHlfc2lnX3B1Yl9rZXkYAyABKAwSLgomaGlnaF9zZWN1cml0eV9wcm9maWxlX3NlZWRfZW5jX3B1Yl9rZXkYBCABKAwSOAowaGlnaF9zZWN1cml0eV9wcm9maWxlX3NlZWRfZW5jX3B1Yl9rZXlfc2lnbmF0dXJlGAUgASgMEhwKFHN0b3JhYmxlX3NpZ19wdWJfa2V5GAYgASgMEiYKHnN0b3JhYmxlX3NpZ19wdWJfa2V5X3NpZ25hdHVyZRgHIAEoDBIpCiFzdG9yYWJsZV9wcm9maWxlX3NlZWRfZW5jX3B1Yl9rZXkYCCABKAwSMworc3RvcmFibGVfcHJvZmlsZV9zZWVkX2VuY19wdWJfa2V5X3NpZ25hdHVyZRgJIAEoDBITCgtzZWNyZXRfaW5mbxgKIAEoCRITCgtzZWNyZXRfc2FsdBgLIAEoDBI0Cgh3ZWJhdXRobhgNIAEoCzIiLmRvbWFpbi5BdXRoZW50aWNhdG9yRGF0YS5XZWJhdXRobhoxCghXZWJhdXRobhITCgt3ZWJhdXRobl9pZBgBIAEoCRIQCghwcmZfc2FsdBgCIAEoDEoECAEQAiKfAwoZQXV0aGVudGljYXRvckNyZWF0aW9uRGF0YRInCgRkYXRhGAEgASgLMhkuZG9tYWluLkF1dGhlbnRpY2F0b3JEYXRhEjcKDXByb2ZpbGVfbG9ja3MYAiADKAsyIC5kb21haW4uUHJvZmlsZUF1dGhlbnRpY2F0b3JMb2NrElUKCHdlYmF1dGhuGAMgASgLMkMuZG9tYWluLkF1dGhlbnRpY2F0b3JDcmVhdGlvbkRhdGEuV2ViYXV0aG5BdXRoZW50aWNhdG9yQ3JlYXRpb25EYXRhEgoKAmlkGAQgASgJGrwBCiFXZWJhdXRobkF1dGhlbnRpY2F0b3JDcmVhdGlvbkRhdGESEwoLd2ViYXV0aG5faWQYASABKAkSEAoIcHJmX3NhbHQYAiABKAwSPAoScHJmX3N1cHBvcnRfc3RhdHVzGAMgASgOMiAuZG9tYWluLldlYmF1dGhuUHJmU3VwcG9ydFN0YXR1cxIbChNyZWdpc3Rlcl9yZXF1ZXN0X2lkGAQgASgJEhUKDXJlc3BvbnNlX2pzb24YBSABKAkiRAoNQXV0aGVudGljYXRvchIKCgJpZBgBIAEoCRInCgRkYXRhGAIgASgLMhkuZG9tYWluLkF1dGhlbnRpY2F0b3JEYXRhIjUKEkF1dGhlbnRpY2F0b3JCbG9jaxIMCgRibG9iGAEgASgMEhEKCXNpZ25hdHVyZRgCIAEoDEIwWi5naXRsYWIuY29tL2NvdGVjaGRlL21vbm9yZXBvL2JhY2tlbmQvZG9tYWluL3BiYgZwcm90bzM", [file_locks, file_authenticator_type, file_webauthn_prf_support_status]);

/**
 * @generated from message domain.AuthenticatorData
 */
export type AuthenticatorData = Message<"domain.AuthenticatorData"> & {
  /**
   * @generated from field: domain.AuthenticatorType authenticator_type = 12;
   */
  authenticatorType: AuthenticatorType;

  /**
   * @generated from field: bytes high_security_login_sig_pub_key = 2;
   */
  highSecurityLoginSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_identity_sig_pub_key = 3;
   */
  highSecurityIdentitySigPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key = 4;
   */
  highSecurityProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes high_security_profile_seed_enc_pub_key_signature = 5;
   */
  highSecurityProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key = 6;
   */
  storableSigPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_sig_pub_key_signature = 7;
   */
  storableSigPubKeySignature: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key = 8;
   */
  storableProfileSeedEncPubKey: Uint8Array;

  /**
   * @generated from field: bytes storable_profile_seed_enc_pub_key_signature = 9;
   */
  storableProfileSeedEncPubKeySignature: Uint8Array;

  /**
   * @generated from field: string secret_info = 10;
   */
  secretInfo: string;

  /**
   * @generated from field: bytes secret_salt = 11;
   */
  secretSalt: Uint8Array;

  /**
   * @generated from field: domain.AuthenticatorData.Webauthn webauthn = 13;
   */
  webauthn?: AuthenticatorData_Webauthn | undefined;
};

/**
 * Describes the message domain.AuthenticatorData.
 * Use `create(AuthenticatorDataSchema)` to create a new message.
 */
export const AuthenticatorDataSchema: GenMessage<AuthenticatorData> = /*@__PURE__*/
  messageDesc(file_authenticator, 0);

/**
 * @generated from message domain.AuthenticatorData.Webauthn
 */
export type AuthenticatorData_Webauthn = Message<"domain.AuthenticatorData.Webauthn"> & {
  /**
   * @generated from field: string webauthn_id = 1;
   */
  webauthnId: string;

  /**
   * @generated from field: bytes prf_salt = 2;
   */
  prfSalt: Uint8Array;
};

/**
 * Describes the message domain.AuthenticatorData.Webauthn.
 * Use `create(AuthenticatorData_WebauthnSchema)` to create a new message.
 */
export const AuthenticatorData_WebauthnSchema: GenMessage<AuthenticatorData_Webauthn> = /*@__PURE__*/
  messageDesc(file_authenticator, 0, 0);

/**
 * @generated from message domain.AuthenticatorCreationData
 */
export type AuthenticatorCreationData = Message<"domain.AuthenticatorCreationData"> & {
  /**
   * @generated from field: domain.AuthenticatorData data = 1;
   */
  data?: AuthenticatorData | undefined;

  /**
   * @generated from field: repeated domain.ProfileAuthenticatorLock profile_locks = 2;
   */
  profileLocks: ProfileAuthenticatorLock[];

  /**
   * @generated from field: domain.AuthenticatorCreationData.WebauthnAuthenticatorCreationData webauthn = 3;
   */
  webauthn?: AuthenticatorCreationData_WebauthnAuthenticatorCreationData | undefined;

  /**
   * Only set for escrow authenticators
   *
   * @generated from field: string id = 4;
   */
  id: string;
};

/**
 * Describes the message domain.AuthenticatorCreationData.
 * Use `create(AuthenticatorCreationDataSchema)` to create a new message.
 */
export const AuthenticatorCreationDataSchema: GenMessage<AuthenticatorCreationData> = /*@__PURE__*/
  messageDesc(file_authenticator, 1);

/**
 * @generated from message domain.AuthenticatorCreationData.WebauthnAuthenticatorCreationData
 */
export type AuthenticatorCreationData_WebauthnAuthenticatorCreationData = Message<"domain.AuthenticatorCreationData.WebauthnAuthenticatorCreationData"> & {
  /**
   * @generated from field: string webauthn_id = 1;
   */
  webauthnId: string;

  /**
   * @generated from field: bytes prf_salt = 2;
   */
  prfSalt: Uint8Array;

  /**
   * @generated from field: domain.WebauthnPrfSupportStatus prf_support_status = 3;
   */
  prfSupportStatus: WebauthnPrfSupportStatus;

  /**
   * if register_request_id and response_json are set, a new credential is created. otherwise,
   * webauthn_id must point to an existing webauthn_credential.
   *
   * @generated from field: string register_request_id = 4;
   */
  registerRequestId: string;

  /**
   * @generated from field: string response_json = 5;
   */
  responseJson: string;
};

/**
 * Describes the message domain.AuthenticatorCreationData.WebauthnAuthenticatorCreationData.
 * Use `create(AuthenticatorCreationData_WebauthnAuthenticatorCreationDataSchema)` to create a new message.
 */
export const AuthenticatorCreationData_WebauthnAuthenticatorCreationDataSchema: GenMessage<AuthenticatorCreationData_WebauthnAuthenticatorCreationData> = /*@__PURE__*/
  messageDesc(file_authenticator, 1, 0);

/**
 * @generated from message domain.Authenticator
 */
export type Authenticator = Message<"domain.Authenticator"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: domain.AuthenticatorData data = 2;
   */
  data?: AuthenticatorData | undefined;
};

/**
 * Describes the message domain.Authenticator.
 * Use `create(AuthenticatorSchema)` to create a new message.
 */
export const AuthenticatorSchema: GenMessage<Authenticator> = /*@__PURE__*/
  messageDesc(file_authenticator, 2);

/**
 * @generated from message domain.AuthenticatorBlock
 */
export type AuthenticatorBlock = Message<"domain.AuthenticatorBlock"> & {
  /**
   * @generated from field: bytes blob = 1;
   */
  blob: Uint8Array;

  /**
   * @generated from field: bytes signature = 2;
   */
  signature: Uint8Array;
};

/**
 * Describes the message domain.AuthenticatorBlock.
 * Use `create(AuthenticatorBlockSchema)` to create a new message.
 */
export const AuthenticatorBlockSchema: GenMessage<AuthenticatorBlock> = /*@__PURE__*/
  messageDesc(file_authenticator, 3);

